import {
  Box,
  createStyles,
  Group,
  Text,
  ThemeIcon,
} from "@mantine/core";
import {
  MdOutlinePhone,
  MdOutlineWbSunny,
  MdOutlineWhatsapp,
} from "react-icons/md";
import { Title } from "../components";
import { MdOutlineSignalCellular0Bar } from "react-icons/md";
import { CONTACT } from "../demo";

const WORKING_HOURS = "09:00 a.m. - 17:00 p.m.";

type Props = {
  id: string;
};

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
    alignItems: "center",
    color: theme.white,
  },

  icon: {
    borderRadius: "8px",
    marginRight: theme.spacing.md,
    backgroundColor: theme.colors.yellow[4],
  },

  title: {
    color: theme.colors.gray[8],
  },

  description: {
    textDecoration: "none",
    color: theme.colors.gray[6],
  },
}));

interface ContactIconProps
  extends Omit<React.ComponentPropsWithoutRef<"div">, "title"> {
  icon: React.FC<any>;
  title: React.ReactNode;
  description: React.ReactNode;
  href?: string;
}

function ContactIcon({
  icon: Icon,
  title,
  description,
  href,
  className,
  ...others
}: ContactIconProps) {
  const { classes, cx } = useStyles();
  return (
    <div className={cx(classes.wrapper, className)} {...others}>
      <ThemeIcon size={40} radius="md" className={classes.icon}>
        <Icon size="1.5rem" />
      </ThemeIcon>

      <div>
        <Text className={classes.title}>{title}</Text>
        {href ? (
          <a href={href} className={classes.description}>
            {description}
          </a>
        ) : (
          <Text className={classes.description}>{description}</Text>
        )}
      </div>
    </div>
  );
}

export default function ContactUs({ id }: Props) {
  return (
    <section id={id}>
      <Title
        title="聯絡我們"
        description="如果您有任何問題，歡迎與我們聯絡。"
      />
      <Box
        sx={(theme) => ({
          padding: theme.spacing.xl,
          borderRadius: theme.radius.md,
          backgroundColor: theme.white,
          marginBottom: theme.spacing.sm,
        })}
      >
        <Group position="apart">
          <ContactIcon
            title="電話"
            description={CONTACT.phoneDisplay}
            icon={MdOutlinePhone}
            href={CONTACT.phoneHref}
          />
          <ContactIcon
            title="Whatsapp"
            description={CONTACT.phoneDisplay}
            icon={MdOutlineWhatsapp}
            href={CONTACT.whatsappHref}
          />
          <ContactIcon
            title="Signal"
            description={CONTACT.phoneDisplay}
            icon={MdOutlineSignalCellular0Bar}
          />
          <ContactIcon
            title="營業時間"
            description={WORKING_HOURS}
            icon={MdOutlineWbSunny}
          />
        </Group>
      </Box>
    </section>
  );
}
